import { useState } from 'react';

export default function OperationFilters() {
  const [activeFilter, setActiveFilter] = useState('all');

  const filters = [
    { id: 'all', label: 'Todas', count: 127 },
    { id: 'in-progress', label: 'En Proceso', count: 45 },
    { id: 'at-risk', label: 'En Riesgo', count: 8 },
    { id: 'completed', label: 'Completadas', count: 74 },
  ];

  return (
    <div className="bg-white rounded-lg p-4 border border-gray-200">
      <div className="flex items-center justify-between gap-4">
        {/* Filter Tabs */}
        <div className="flex gap-2">
          {filters.map((filter) => (
            <button
              key={filter.id}
              onClick={() => setActiveFilter(filter.id)}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeFilter === filter.id
                  ? 'bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white'
                  : 'bg-gray-100 text-[#6B7280] hover:bg-gray-200'
              }`}
            >
              {filter.label}
              <span className="ml-2 px-2 py-0.5 rounded-full text-xs bg-white/20">
                {filter.count}
              </span>
            </button>
          ))}
        </div>

        {/* Search and Actions */}
        <div className="flex items-center gap-3">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <i className="ri-search-line text-[#6B7280] text-sm"></i>
            </div>
            <input
              type="text"
              placeholder="Buscar operación..."
              className="pl-10 pr-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent w-64"
            />
          </div>
          <button className="w-9 h-9 flex items-center justify-center rounded-md border border-gray-200 hover:bg-gray-50 transition-colors cursor-pointer">
            <i className="ri-filter-3-line text-[#6B7280]"></i>
          </button>
          <button className="w-9 h-9 flex items-center justify-center rounded-md border border-gray-200 hover:bg-gray-50 transition-colors cursor-pointer">
            <i className="ri-download-line text-[#6B7280]"></i>
          </button>
        </div>
      </div>
    </div>
  );
}